import { isAxiosError } from 'axios'

import { HttpError } from '@webapp/infrastructure/interfaces/services/IHttpClient'

/**
 * Extracts an error message from an HTTP error response.
 *
 * Handles the Django proxy response format: [{ message: "..." }]
 *
 * @param error - The error object (AxiosError or HttpError)
 * @returns The extracted error message, or undefined if not found
 */
export const extractHttpErrorMessage = (error: unknown): string | undefined => {
  let responseData: unknown

  if (isAxiosError(error)) {
    responseData = error.response?.data
  } else if (error instanceof HttpError) {
    responseData = error.response
  }

  // Django proxy returns errors as: [{ message: "...", code: "..." }]
  if (
    Array.isArray(responseData) &&
    responseData.length > 0 &&
    typeof responseData[0]?.message === 'string'
  ) {
    return responseData[0].message
  }

  return undefined
}
